<template>
    <div class="stats container-fluid">
        <h1>Stats</h1>
        
        <template v-if="stats">
            <h3>User Stats</h3>
            <div class="same-height-tiles">
                <div v-for="(count, stat) in stats.user" :key="stat" class="tile shadow p-3 stat-tile stat-numeric">
                    <div class="count">{{ count }}</div>
                    <h4 class="stat-title">{{ stat }}</h4>
                </div>
            </div>
            
            <h3>List Stats</h3>
            <div class="same-height-tiles">
                <div v-for="(count, stat) in stats.lists" :key="stat" class="tile shadow p-3 stat-tile stat-numeric">
                    <div class="count">{{ count }}</div>
                    <h4 class="stat-title">{{ stat }}</h4>
                </div>
            </div>
            
            <h3>Regional Stats</h3>
            <div class="same-height-tiles">
                <div v-for="(info, region) in stats.regions" :key="region" class="tile shadow p-3">
                    <ul class="list-unstyled mb-0">
                        <li><b>Total Sites:</b> {{ info.total }}</li>
                        <li><b>Clothing Optional:</b> {{ info.clothing_optional }}</li>
                        <li><b>Clothing Required:</b> {{ info.clothing_required }}</li>
                        <li><b>Unknown:</b> {{ info.unknown_attire }}</li>
                        <li><b>Favorites:</b> {{ info.lists.favorites }}</li>
                        <li><b>Visited:</b> {{ info.lists.visits }}</li>
                    </ul>
                    <h4 class="stat-title">{{ region }}</h4>
                </div>
            </div>
        </template>
        
        <template v-else>Stats not loaded</template>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'Stats',
    head: {
        title() {
            return {
                inner: 'Stats',
            }
        },
    },
    data() {
        return {
            stats: null,
        }
    },
    methods: {
    },
    created() {
        axios({
            url: process.env.VUE_APP_API_BASE_URL + `/stats`,
            method: 'GET',
        }).then(response => {
            this.stats = response.data.data
        }).catch(error => {
            console.log({ error: error })
        })
    },
};
</script>

<style lang="scss" scoped>
    .stat-title {
        margin-top: 10px;
        margin-bottom: 0;
    }
</style>